import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=6d3ac89c&scoped=true&"
import script from "./branch.vue?vue&type=script&lang=js&"
export * from "./branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ac89c",
  null
  
)

export default component.exports